<ng-container *ngIf="!isNewEDPScoreboard; else leaderBoard">
    <div
        class="event-name"
        [ngClass]="{
            'event-started': players.length === 0,
            'event-name-without-lap': event.sport.id === sportType.Skialpine || event.sport.id === sportType.Biathlon,
        }">
        <ms-favourite-event-toggle class="participant-favourite" [event]="event"> </ms-favourite-event-toggle>
        <span class="participant-name">{{ event.name }}: {{ event.league.name }}</span>
    </div>
    <div
        [ngClass]="{
            'laps-weather-info': displayLaps,
            'laps-weather-hide': !displayLaps,
        }">
        <span class="laps" *ngIf="score.type">{{ score.type }}: {{ score.current }}/{{ score.final }}</span>
        <span class="weather" *ngIf="weather !== null">
            <span class="lap-weather-divider"></span><vn-icon name="sports-sb-weather-{{ weather }}-i" size="11"></vn-icon>
        </span>
    </div>
    <div class="participant-overview" *ngIf="players.length >= 1" [ngClass]="players.length > 5 ? 'two-column' : 'one-column'">
        <ng-container *ngFor="let participant of players; let i = index">
            <span class="participant" *ngIf="participant.name"
                >{{ i + 1 }}. {{ participant.name }}
                <span class="make-country-info" *ngIf="participant.country">
                    <span
                        class="participant-country"
                        *ngIf="event.sport.id === sportType.Skialpine || event.sport.id === sportType.Biathlon; else showMake">
                        {{ participant.country.substring(0, participant.country.indexOf('/')) }}</span
                    >
                    <ng-template #showMake class="participant-country">
                        {{ participant.country.substring(participant.country.indexOf('/') + 1) }}</ng-template
                    >
                </span>
            </span>
        </ng-container>
    </div>
</ng-container>
<ng-template #leaderBoard>
    <div class="event-header-live">
        <i class="live-icon"></i>
        <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard"> </ms-event-timer>
    </div>
    <div class="participant-info">
        <ms-participant-image
            class="participant-image"
            [participantImage]="event.league.imageProfile"
            [sportId]="event.sport.id"
            [showLogoColor]="true">
        </ms-participant-image>
        <div class="participant-name">
            {{ event.name }}
            <span class="participant-country">{{ event.league.name }}</span>
        </div>
    </div>
</ng-template>
